module.exports = __webpack_public_path__ + "img/page2-bg-phone.266c88f6.png";